exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-premium[data-v-ad9c6176] {\n  background: linear-gradient(90deg, #FFC107 0%, #FFEB3B 100%);\n}\n.font-shadow-sm[data-v-ad9c6176] {\n  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);\n}\n@media only screen and (min-width: 768px) {\n.md\\:w-70-p[data-v-ad9c6176] {\n    width: 77%;\n}\n}", ""]);

// exports
